import { action } from 'easy-peasy';
import { IActionHideSidebarMenu } from '~/store/app/types';

const hideSidebar: IActionHideSidebarMenu = action(state => {
  state.sidebarMenuOpened = false;
});

export default hideSidebar;
